import { selectStore } from "../../store/selectors/StoreSelector";
import { Store } from "../../entity/Store";
import { store } from "../../store/Store";

export class AccessManager {
  private static instance: AccessManager;

  private constructor() {}

  public static getInstance(): AccessManager {
    if (!AccessManager.instance) {
      AccessManager.instance = new AccessManager();
    }
    return AccessManager.instance;
  }

  private getStore(): Store | null {
    return selectStore(store.getState());
  }

  public hasAccess(): boolean {
    const storeData = this.getStore();
    let isHasAnAccess = false;

    if (storeData?.packConfig?.isTrial) {
      isHasAnAccess = true;
    } else if (storeData?.packConfig?.expiredAt) {
      // expiredAt is a Firestore Timestamp → convert to Date
      const expiredDate: Date = storeData.packConfig.expiredAt;

      // Add one day (24h) grace period
      const gracePeriod = expiredDate.getTime() + 24 * 60 * 60 * 1000;

      if (gracePeriod > new Date().getTime()) {
        isHasAnAccess = true;
      }
    }

    return isHasAnAccess;
  }

  public isExpired(): boolean {
    const storeData = this.getStore();
    if (!storeData?.packConfig?.expiredAt) return false;

    const expiredDate: Date = storeData.packConfig.expiredAt;
    return expiredDate.getTime() < new Date().getTime();
  }
}
